const common = {
  googleMaps: {
    apiKey: 'AIzaSyB3Sb4BjsAg9n_0Qsd3ExDMC7C6J2Vc2nU'
  },
  sentry: {
    dsn: 'https://af0bb937f7c04920bd1dc838acf70ab2@sentry.io/1285953',
    blacklistUrls: ['localhost', '127.0.0.1']
  }
}

const development = {
  ...common,
  firebase: {
    apiKey: 'AIzaSyB0aPB0Op9mEmdFz17ZB9eKn5Txss5ykB8',
    authDomain: 'outfox-dev.firebaseapp.com',
    databaseURL: 'https://outfox-dev.firebaseio.com',
    projectId: 'outfox-dev',
    storageBucket: 'outfox-dev.appspot.com',
    messagingSenderId: '366980509090'
  },
  sentry: {
    ...common.sentry,
    environment: 'development'
  }
}

const production = {
  ...common,
  firebase: {
    apiKey: 'AIzaSyAWLlv4z4esn3nXEAqa7vtYYGuFmZecZeA',
    authDomain: 'outfox-ai.firebaseapp.com',
    databaseURL: 'https://outfox-ai.firebaseio.com',
    projectId: 'outfox-ai',
    storageBucket: 'outfox-ai.appspot.com',
    messagingSenderId: '881610517662'
  },
  sentry: {
    ...common.sentry,
    environment: 'production'
  }
}

const ENVIRONMENT = 'production'

let activeConfig
switch (ENVIRONMENT) {
  case 'production':
    activeConfig = production
    break
  case 'development':
    activeConfig = development
    break
  default:
    throw new Error('Unrecognised environment')
}

export default activeConfig
